/**
 * Mensagens padrão das ações de agenda, prontas para envio, e o template WABA equivalente.
 *
 * `wabaName` é o prefixo que o broker-api dá ao template criado junto com o WABA
 * (`03 - zandu-broker-api/src/modules/creatives/creative-default-templates.service.ts`), seguido
 * de `_01_<sufixo aleatório>` — por isso a busca é por `startsWith`.
 *
 * As duas usam a ação `automacao_agenda_confirmar`: o que distingue lembrete de confirmação é
 * só o texto. Por isso a tela de mensagem reconhece o lembrete comparando `message` com
 * `lembrete.text`; se a pessoa já editou o texto, a escolha do template fica com ela.
 */
export const DEFAULT_MESSAGES = {
    confirmacao: {
        text: 'Olá {primeironome}. Podemos confirmar seu agendamento dia {dataevento} às {horaevento}?\n\nClique no link abaixo para confirmar ou cancelar.\n{agendalink}',
        wabaName: 'zandu_default_appointment_confirmation',
    },
    lembrete: {
        text: 'Olá {primeironome}. Estou passando apenas para lembrar de seu agendamento daqui a pouco às {horaevento}.\n\nAguardo você.',
        wabaName: 'zandu_default_remember',
    },
}
